import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export interface ManuButtonProps {
  children?: React.ReactNode;
  items: string[];
  endIcon?: JSX.Element;
  variant?: "text" | "contained" | "outlined";
  onSelect?: (val: string) => void;
}

export const MenuButton: React.FC<ManuButtonProps> = ({ children, items, onSelect, endIcon, variant }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-haspopup="true"
        onClick={handleClick}
        endIcon={endIcon ?? <ArrowDropDownIcon />}
        aria-expanded={open ? 'true' : undefined}
        aria-controls={open ? 'basic-menu' : undefined}
        variant={variant ?? "contained"}
      >
        {children}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {items.map((val, i) => {
          return <MenuItem
            key={i}
            onClick={() => {
              if (onSelect) onSelect(val);
              handleClose();
            }}>{val}</MenuItem>;
        })}
      </Menu>
    </div>
  );
};